// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2E6m4","paramInput":"JobSimulator_paramInput__3pG0M","input":"JobSimulator_input__1Nn6R"};